import { CategoryPreferences, Destination } from '@segment/consent-manager/types/types';

import { ADVERTISING_CATEGORIES, FUNCTIONAL_CATEGORIES } from './categories';

export const handleMapCustomPreferences = (destinations: Destination[], preferences: CategoryPreferences) => {
  const customPreferences: CategoryPreferences = {};
  const destinationPreferences: CategoryPreferences = {};

  for (const preferenceName of Object.keys(preferences)) {
    const value = preferences[preferenceName];
    customPreferences[preferenceName] = typeof value === 'boolean' ? value : true;
  }

  const customPrefs = customPreferences as CategoryPreferences;

  for (const destination of destinations) {
    // Mark advertising destinations
    if (ADVERTISING_CATEGORIES.find(category => category === destination.category) && destinationPreferences[destination.id] !== false)
      destinationPreferences[destination.id] = customPrefs.advertising;

    // Mark function destinations
    if (FUNCTIONAL_CATEGORIES.find(category => category === destination.category) && destinationPreferences[destination.id] !== false)
      destinationPreferences[destination.id] = customPrefs.functional;

    // Fallback to marketing
    if (!(destination.id in destinationPreferences)) destinationPreferences[destination.id] = customPrefs.marketingAndAnalytics;
  }

  return { destinationPreferences, customPreferences };
};
